import React from 'react';
import { CONTACTS } from '../constants/contacts';
import styles from '../pages/Resume.module.scss';

function ContactLinks() {
    return (
        <div className={styles.contacts}>
            {CONTACTS.map((contact, idx) => {
                const isExternal = !contact.url.startsWith('mailto:');
                return (
                    <a
                        key={idx}
                        href={contact.url}
                        className={styles.contactLink}
                        {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                        {contact.emoji} {contact.label}
                    </a>
                );
            })}
        </div>
    );
}

export default ContactLinks;
